import {Box} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {useTheme} from "../../contexts/theme";
import {moveTrimPoint} from "./utils/utils";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const barHeight = 10

function StartGrabber(props) {
    return (
        <PlayArrowIcon tabIndex='0' {...props} style={{transform: 'rotate(90deg)'}}/>
    );
}

function EndGrabber(props) {
    return (
        <PlayArrowIcon tabIndex='0' {...props} style={{transform: 'rotate(-90deg)'}}/>
    );
}


export default function KeyMomentVideoPlayerBar ({setVideoCurrentDuration,setIsGrabberDragging, mergeTrimPoints, updateTrimPoint ,onDeleteGrabber, videoCurrentTime ,totalVideoTime ,trimPoints ,setCurrentFocus, onBlur}) {

    const theme = useTheme();
    const barRef = useRef(null);
    const [gradientBackGround, setGradientBackGround] = useState();
    const selectedGrabber = useRef();

    function VideoPlayerBar({left} ){
        return (
            <Box
                width={'2px'}
                height={(barHeight + 10) + 'px'}
                sx={{backgroundColor: theme.palette.black, zIndex: 10}}
                position='absolute'
                left={left}
                tabIndex={0}
                onFocus={() => setCurrentFocus({type: 'startGrabber', index: -1})}
                onBlur={onBlur}
            />
        )
    }

    function onGrabEnd() {
        window.removeEventListener('mousemove', onGrabMove);
        window.removeEventListener('mouseup', onGrabEnd);
        setIsGrabberDragging(false);
    }


    function onGrabMove(event) {
        const playbackRect = barRef.current.getBoundingClientRect();
        const seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
        const index = selectedGrabber.current.index;
        const type = selectedGrabber.current.type;
        const seek = totalVideoTime * seekRatio
        moveTrimPoint(trimPoints, seek, totalVideoTime, index, type, onDeleteGrabber, updateTrimPoint, mergeTrimPoints, {
                use: false,
                shots: []
            });
    }

    function onGrabberSelection(grabberIndex, type, time) {

            setIsGrabberDragging(true);
            selectedGrabber.current = {index: grabberIndex, type, time};
            setVideoCurrentDuration(time)
            window.addEventListener('mousemove', onGrabMove);
            window.addEventListener('mouseup', onGrabEnd);

    }

    function calculateBackground() {
        if (trimPoints.length > 0) {
            let colors = '';
            let counter = 0;
            const activeColor = theme.palette.red;
            const deactiveColor = theme.palette.lightGrey;
            colors += `, ${activeColor} 0%, ${activeColor} ${trimPoints[0].start / totalVideoTime * 100}%`
            for (let trimPoint of trimPoints) {
                if (counter > 0) {
                    colors += `, ${activeColor} ${trimPoints[counter - 1].end / totalVideoTime * 100}%, ${activeColor} ${trimPoint.start / totalVideoTime * 100}%`
                }
                colors += `, ${deactiveColor} ${trimPoint.start / totalVideoTime * 100}%, ${deactiveColor} ${trimPoint.end / totalVideoTime * 100}%`
                counter += 1
            }
            colors += `, ${activeColor} ${trimPoints[counter - 1].end / totalVideoTime * 100}%, ${activeColor} 100%`
            setGradientBackGround(`linear-gradient(to right ${colors})`);
        } else {
            setGradientBackGround(theme.palette.lightGrey)
        }
    }

    function getLeftOffset(time) {
        if (barRef.current) {
            const currentWidth = barRef.current.clientWidth;
            return ((time / totalVideoTime) * currentWidth)
        } else {
            return 0;
        }
    }

    function onBarClick(e) {
        if (barRef && barRef.current) {
            const playbackRect = barRef.current.getBoundingClientRect();
            const seekTime = ((e.clientX - playbackRect.left) / playbackRect.width) * totalVideoTime;
            setVideoCurrentDuration(seekTime)
        }
    }

    useEffect(() => {
        calculateBackground();
    }, [trimPoints, totalVideoTime]);




    return (
        <Box ref={barRef} onClick={onBarClick} position={'relative'} height={barHeight + 'px'}
             sx={{background: gradientBackGround, borderRadius: theme.border.radius.md}}>
            {trimPoints.map((trimPoint, index) => (
                <React.Fragment key={'Trimpoints' + index}>
                    <StartGrabber
                        onMouseDown={() => onGrabberSelection(index, 'start', trimPoint.start)}
                        onFocus={() => setCurrentFocus({type: 'startGrabber', index})}
                        onBlur={onBlur}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            position: 'absolute',
                            left: (getLeftOffset(trimPoint.start) - 12) + 'px',
                            color: 'green',
                            top: -(barHeight + 10) + 'px',
                            tabIndex: 0
                        }}></StartGrabber>
                    <EndGrabber
                        onMouseDown={() => onGrabberSelection(index, 'end', trimPoint.end)}
                        onFocus={() => setCurrentFocus({type: 'endGrabber', index})}
                        onBlur={onBlur}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            position: 'absolute',
                            left: (getLeftOffset(trimPoint.end) - 12) + 'px',
                            color: 'red',
                            top: (barHeight - 2) + 'px',
                            tabIndex: 0
                        }}></EndGrabber>
                </React.Fragment>
            ))}


            <VideoPlayerBar left={getLeftOffset(videoCurrentTime) + 'px'}/>
        </Box>
    );
}